const loadingDone = () => {
    return {
        type: "LOADING_COMPLETE",
        payload: {}
    }
};

const pageView = () => {
    return {
        type: "PAGE_VIEW",
        payload: new Promise( (resolve, reject) => {
            return resolve({})
        })
    }
};

export {loadingDone, pageView};


// WEBPACK FOOTER //
// ./src/actions/Util.js